<template>
  <div style="overflow-y: scroll; height: 100vh;">
    <h1 class="mb-3 mt-3" style="text-align: center;">TEST IN APP WEBVIEW</h1>
    <h4 class="mt-3 ml-3">Received Data: {{ receivedData }}</h4>
    <v-divider class="mt-3 mb-3"></v-divider>
    <v-layout column warp class="justify-start">
      <!-- ส่งข้อมูลไปให้แอปเพื่อ save secure code -->
      <v-btn class="text-transform" @click="sendDataToWebView('op_save_secure_code', { message: 'save-secure-code', key: '1234' })" color="green" dark>Send save-secure-code to WebView</v-btn>
      <!-- ส่งข้อมูลไปให้แอปเพื่อ delete secure code -->
      <v-btn class="text-transform" @click="sendDataToWebView('op_delete_secure_code', 'delete-secure-code')" color="green" dark>Send delete-secure-code to WebView</v-btn>
      <!-- เปิดเว็บข้างนอกแอป -->
      <v-btn class="text-transform" @click="sendDataToWebView('op_openwebview', { message: 'https://www.google.com/' })" color="green">Open Webview</v-btn>

      <v-divider class="mt-3 mb-3"></v-divider>
      <!-- เก็ทข้อมูล secure code จากแอป -->
      <v-btn class="text-transform" @click="getDataToWebView('op_get_secure_code', 'get-secure-code')" color="primary">Get Data op_get_secure_code from Flutter</v-btn>
      <!-- เก็ทข้อมูล device จากแอป -->
      <v-btn class="text-transform" @click="getDataToWebView('op_get_device_info', 'get-device-info')" color="primary">Get Data op_get_device_info from Flutter</v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      receivedData: '',
    }
  },
  mounted() {
    // เพิ่ม event ที่รอรับค่าจากแอป
    window.addEventListener('op_save_secure_code', async (event) => {
      this.receivedData = event;
    })
    window.addEventListener('op_delete_secure_code', async (event) => {
      this.receivedData = event;
    })
    window.addEventListener('op_get_secure_code', async (event) => {
      this.receivedData = event;
    })
    window.addEventListener('op_get_device_info', async (event) => {
      this.receivedData = event;
    })
    window.addEventListener('op_openwebview', async (event) => {
      this.receivedData = event;
    })
  },
  beforeDestroy() {
    // ลบ event ที่รับค่าจากแอป
    window.removeEventListener('op_save_secure_code', async (event) => {
      this.receivedData = event;
    })
    window.removeEventListener('op_delete_secure_code', async (event) => {
      this.receivedData = event;
    })
    window.removeEventListener('op_get_secure_code', async (event) => {
      this.receivedData = event;
    })
    window.removeEventListener('op_get_device_info', async (event) => {
      this.receivedData = event;
    })
    window.removeEventListener('op_openwebview', async (event) => {
      this.receivedData = event;
    })
  },
  methods: {
    sendDataToWebView(type, item) {
      // item สามารถส่งเป็น string หรือ json ก็ได้
      // ส่ง item ไปที่ Flutter app โดยใช้ the 'type' method ที่ส่งมาในฟังก์ชัน
      window.flutter_inappwebview.callHandler(type, item);
    },
    getDataToWebView(type, value) {
      // type คือ ชื่อของ methods ที่ตกลงกับฝั่งแอปว่าจะใช้เป็นชื่ออะไร
      // value คือ ค่าที่จะส่งให้ไปฝั่งแอป เป็น string หรือ json ก็ได้
      window.flutter_inappwebview
        .callHandler(type, value)
        .then(result => {
          this.receivedData = result
      });
    },
  },
};
</script>
<style media="screen" scoped>
  .text-transform {
    text-transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/code_inappwebview.vue